import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { AuthContext } from "./AuthContext";
import moment from "moment/moment";
import { generateSummary } from "./helper/pay.summary";
import { getBillsInRealTime, getClearedBillsInRealTime, getPaymentsInRealTime, getReceivedPaymentsInRealTime, getRevenueBillsInRealTime } from "../Config/db/bills.operations";
import { AccountContext } from "./AccountContext";

export const PayContext = createContext();

const initialStateSummary = {
  revenue: {
    estimated: 0,
    generated: 0,
    outstanding: 0,
    accounts: 0,
  },
  expense: {
    estimated: 0,
    spent: 0,
    pending: 0,
    accounts: 0,
  },
};

export const PayContextProvider = ({ children }) => {
  const { userInfo, totalFlats } = useContext(AuthContext);
  const { accounts, primaryAccount } = useContext(AccountContext);

  const [summary, setSummary] = useState(initialStateSummary);

  const [summaryFilter, setSummaryFilter] = useState({
    filterType: "month",
    value: [moment().startOf("month"), moment().endOf("month")],
  });

  const [bills, setBills] = useState([]);

  const [payments, setPayments] = useState([]);

  const [receivedPayments, setReceivedPayments] = useState([]);

  const [clearedBills, setReceivedBills] = useState([]);

  const [revenueBills, setRevenueBills] = useState([]);

  /* Payments data */
  useEffect(() => {
    if (userInfo?.communityCode && userInfo?.flats?.length > 0) {
      const unsub = getPaymentsInRealTime(userInfo?.communityCode, userInfo?.flats, (data) => {
        setPayments(data)
      });
      return () => unsub?.();
    }
  }, [userInfo]);

   /* Received Payments data */
   useEffect(() => {
    if (userInfo?.communityCode && userInfo?.flats?.length > 0) {
      const unsub = getReceivedPaymentsInRealTime(userInfo?.communityCode, userInfo?.flats, (data) => {
        setReceivedPayments(data)
      });
      return () => unsub?.();
    }
  }, [userInfo]);

  /* Bills data */
  useEffect(() => {
    if (userInfo?.communityCode) {
      const unsub = getBillsInRealTime(userInfo?.communityCode, (data) => {
        setBills(data)
      });
      return () => unsub?.();
    }
  }, [userInfo]);

    /* Cleared Bills data */
    useEffect(() => {
      if (userInfo?.communityCode) {
        const unsub = getClearedBillsInRealTime(userInfo?.communityCode, (data) => {
          setReceivedBills(data)
        });
        return () => unsub?.();
      }
    }, [userInfo]);
    /* All Revenue Bills (community-wide, for project journey) */
    useEffect(() => {
      if (userInfo?.communityCode) {
        const unsub = getRevenueBillsInRealTime(userInfo?.communityCode, (data) => {
          setRevenueBills(data);
        });
        return () => unsub?.();
      }
    }, [userInfo]);
  /* Summary data */
  useEffect(() => {
    const summaryGenerated = generateSummary(accounts, primaryAccount, receivedPayments, clearedBills, summaryFilter, totalFlats);
    setSummary(summaryGenerated);
  }, [summaryFilter, accounts, primaryAccount, receivedPayments, clearedBills, totalFlats]);

  const contextValue = useMemo(() => ({
    summaryFilter,
    setSummaryFilter,
    summary,
    bills,
    payments,
    revenueBills,
    receivedPayments,
    clearedBills,
  }), [summaryFilter, summary, bills, payments, revenueBills, receivedPayments, clearedBills]);

  return (
    <PayContext.Provider value={contextValue}>
      {children}
    </PayContext.Provider>
  );
};
